//常用函数

/* 计算两日期相差的日期年月日等 */
//dateDiff 方法
//返回两个日期对象之间的时间间隔。
//interval ：D表示查询精确到天数的之差
//interval ：H表示查询精确到小时之差
//interval ：M表示查询精确到分钟之差
//interval ：S表示查询精确到秒之差
//interval ：T表示查询精确到毫秒之差

import FileSaver from "file-saver";

//import * as XLSX from 'xlsx'

function DateDiff(interval, date1, date2) {
    interval = interval.toUpperCase();
         
    var objInterval;
    if (interval == 'MM') {
        //用-分成数组
        var d1 = date1.split("-");
         
        var d2 = date2.split("-");
        //获取年,月数
        var year1 = parseInt(d1[0]),
            month1 = parseInt(d1[1]),
            year2 = parseInt(d2[0]),
            month2 = parseInt(d2[1]),
            //通过年,月差计算月份差
            months = (year2 - year1) * 12 + (month2 - month1) + 1;
        var date = months;
    }
    else {
        if (interval == 'H')
            objInterval = 1000 * 60 * 60;
        else if (interval == 'D')
            objInterval = 1000 * 60 * 60 * 24;
        else if (interval == 'M')
            objInterval = 1000 * 60;
        else if (interval == 'S')
            objInterval = 1000;
        else if (interval == 'T')
            objInterval = 1;
             
        var dt1 = Date.parse(date1.replace(/-/g, '/'));
        var dt2 = Date.parse(date2.replace(/-/g, '/'));
        try {
            var date = Math.round((dt2 - dt1) / objInterval);
        }
        catch (e) {
            return e.message;
        }

    }
    return date;
}
//格式化日期
function formatDate(date, fmt) {
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
            RegExp.$1,
            (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
    }
    let o = {
        "M+": date.getMonth() + 1,
        "d+": date.getDate(),
        "h+": date.getHours(),
        "m+": date.getMinutes(),
        "s+": date.getSeconds()
    };
    for (let k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(
                RegExp.$1,
                RegExp.$1.length == 1
                    ? o[k]
                    : ("00" + o[k]).substr(("" + o[k]).length)
            );
        }
    }
    return fmt;
}

function toFixed(value, digitNum) {
    if ((value == undefined || value == null || value == '' || isNaN(value)) && value != 0) {
        return '-';
    }
    if ((digitNum == undefined || digitNum == null || digitNum == '' || isNaN(digitNum)) && value != 0) {
        return value;
    }
    return value.toFixed(digitNum);
}
function getRounding(value, num) {
    let t = 1;
    for (let i = 0; i < num; i++) {
        t = t * 10;
    }
    return Math.round(value * t) / t;
}

function numArrySort(arr) {
    let sortObj = arr.sort(function (a, b) {
        return a - b;
    });
    return sortObj;
}

function getAvgValue(arr) {
    let avg = 0;
    let sum = 0;
    arr.forEach((num, index, l) => {
        sum += num;
    })
    avg = sum / arr.length;
    return avg;
}

//获取四分位数（组）
function getMedianData(obj) {
    let arry = [];
    if (obj.length == 0) {
        return [0, 0, 0, 0, 0];
    }
    let sortObj = obj.sort(function (a, b) {
        return a - b;
    });
    //最小值
    arry.push(sortObj[0]);
    let q1 = 0;
    let q2 = 0;
    let q3 = 0;
    q2 = getMedian(sortObj);
    if (sortObj.length % 2 == 0) {
        if (sortObj.length == 0) {
            q2 = 0;
        } else {
            let newObj1 = sortObj.slice(0, sortObj.length / 2);
            let newObj2 = sortObj.slice(sortObj.length / 2);
            q1 = getMedian(newObj1);
            q3 = getMedian(newObj2);
        }
    } else {
        let newObj1 = sortObj.slice(0, (sortObj.length - 1) / 2);
        let newObj2 = sortObj.slice((sortObj.length + 1) / 2);
        q1 = getMedian(newObj1);
        q3 = getMedian(newObj2);
    }
    arry.push(q1);
    arry.push(q2);
    arry.push(q3);
    //最大值
    arry.push(sortObj[sortObj.length - 1]);
    return arry;
}
//获取中位数
function getMedian(obj) {
    let num = 0;
    let sortObj = obj.sort(function (a, b) {
        return a - b;
    });
    if (sortObj.length % 2 == 1) {
        num = sortObj[(sortObj.length + 1) / 2 - 1];
    } else {
        switch (sortObj.length) {
            case 0:
                num = 0;
                break;
            case 2:
                num = (sortObj[0] + sortObj[1]) / 2;
                break;
            default:
                num =
                    (sortObj[sortObj.length / 2] + sortObj[sortObj.length / 2 - 1]) /
                    2;
                break;
        }
    }
    return num;
}

function DownloadFile(blobData, blobType, fileName) {
    var param = {};
    blobType ? param.type = blobType : {};
    var blob = new Blob([blobData], param);
    // 针对于IE浏览器的处理, 因部分IE浏览器不支持createObjectURL
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
        var downloadElement = document.createElement("a");
        var href = window.URL.createObjectURL(blob); // 创建下载的链接
        downloadElement.href = href;
        downloadElement.download = fileName; // 下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); // 点击下载
        document.body.removeChild(downloadElement); // 下载完成移除元素
        window.URL.revokeObjectURL(href); // 释放掉blob对象
    }
}

function byteLength(str) {  //获取字符串的字节数，扩展string类型方法
    
    var b = 0; var l = str.length;  //初始化字节数递加变量并获取字符串参数的字符个数
    if (l) {  //如果存在字符串，则执行计划
        for (var i = 0; i < l; i++) {  //遍历字符串，枚举每个字符
            if (str.charCodeAt(i) > 255) {  //字符编码大于255，说明是双字节字符
                b += 2;  //则累加2个
            } else {
                b++;  //否则递加一次
            }
        }
        return b;  //返回字节数
    } else {
        return 0;  //如果参数为空，则返回0个
    }
}
//格式化日期
function formatDate24(date, fmt) {
     
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
            RegExp.$1,
            (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
    }
    let o = {
        "M+": date.getMonth() + 1,
        "d+": date.getDate(),
        "H+": date.getHours(),
        "m+": date.getMinutes(),
        "s+": date.getSeconds(),
        "S" :  date.getMilliseconds()
    };
    for (let k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(
                RegExp.$1,
                RegExp.$1.length == 1
                    ? o[k]
                    : ("00" + o[k]).substr(("" + o[k]).length)
            );
        }
    }
    return fmt;
}

//获取审核状态 根据项目级别 菜单级别
function getAuditStatus(checkLevel,level) {
    var auditStatuss={};
    var addStatus=[];
    var queryStatus=[];
   if(Number(checkLevel) == 3){
        switch (Number(level)) {
            case 1:
                addStatus={"审核":"0"};
                queryStatus=["null","2"];
                break;
            case 2:
                addStatus={"审核":"1","退回":"2"};
                // addStatus=["1","2"]
                queryStatus=["0","4"];
                break;

            case 3:
                addStatus={"审核":"3","退回":"4","撤销":"1"};
                // addStatus=["3","4","1"]
                queryStatus=["1"];
                break;
        }
   }else if(Number(checkLevel)==2){
        switch (Number(level)) {
            case 1:
                addStatus={"审核":"0"};
                // addStatus=["0"]
                queryStatus=["null","2"];
                break;
            case 3:
                addStatus={"审核":"3","退回":"2","撤销":"0"};
                // addStatus=["3","2","0"]
                queryStatus=["0"];
                break;
        }

   }else if(Number(checkLevel)==1){
        switch (Number(level)) {
            case 3:
                // addStatus=["null","3"]
                addStatus={"审核":"3","撤销":null};
                queryStatus=["null"];
                break;
        }

   }
   auditStatuss={addStatus:addStatus,queryStatus:queryStatus};
   
   console.log("utils:getAuditStatus",auditStatuss)
   return auditStatuss;
    
}
//获取审核状态 根据项目级别
function getCalendarAuditStatus(checkLevel) {
    var auditStatuss={};
   if(Number(checkLevel) == 3){
    auditStatuss={"未审核":null,"已审核":"0","已复核":"1","复核退回":"2","已审定":"3","审定退回":"4","审定撤销":"1"};
   }else if(Number(checkLevel)==2){
    auditStatuss={"未审核":null,"已审核":"0","已审定":"3","审定退回":"2","审定撤销":"0"};
   }else if(Number(checkLevel)==1){
    auditStatuss={"已审定":"3","已撤销":null};
   }

   return auditStatuss;
}

//获取审核统计 根据项目级别
function getCalendarAuditStatus1(checkLevel) {
    var auditStatuss={};
   if(Number(checkLevel) == 3){
    auditStatuss={"未审核":null,"已审核":"0","已复核":"1","复核退回":"2","已审定":"3","审定退回":"4"};
   }else if(Number(checkLevel)==2){
    auditStatuss={"未审核":null,"已审核":"0","已审定":"3","审定退回":"2"};
   }else if(Number(checkLevel)==1){
    auditStatuss={"已审定":"3","未审核":null};
   }

   return auditStatuss;
}
//小数位不足位数补0
function DigitNumFormat(val, digitNum) {
    var result;
    if (val == null || isNaN(val) || val=="" || digitNum == null || isNaN(digitNum)) { result= val; }

    val = val + "";
    var indxOf = val.indexOf(".");
    if ((val.length - indxOf) <= digitNum || indxOf == -1) {
        result= parseFloat(val).toFixed(digitNum);
    } else {
        result= val;
    }

    return isNaN(result)?"-":result;
}
//获取水质等级及颜色
function GetWaterLevel(intLeve){
    if(intLeve==1){ return {level:"Ⅰ",color:"#ffffff",background:"#59d6ff"}; }
    if(intLeve==2){ return {level:"Ⅱ",color:"black",background:"#18acf2"}; }
    if(intLeve==3){ return {level:"Ⅲ",color:"black",background:"#01ff01"}; }
    if(intLeve==4){ return {level:"Ⅳ",color:"black",background:"#feff01"}; }
    if(intLeve==5){ return {level:"Ⅴ",color:"#ffffff",background:"#fd8200"}; }
    if(intLeve==6){ return {level:"劣Ⅴ",color:"#ffffff",background:"#fd0001"}; }

    return {level:"-",color:"",background:""};
}
//生成唯一id 如："a1ca0f7b-51bd-4bf3-a5d5-6a74f6adc1c7"
function guid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}
function getUrlPara(){
    var url = window.location.href ;             //获取当前url
    var dz_url = url.split('#')[0];                //获取#/之前的字符串
    var cs = url.split('?')[1];                //获取?之后的参数字符串
    if(cs)
    {
        var cs_arr = cs.split('&');                    //参数字符串分割为数组
        var cs={};
        for(var i=0;i<cs_arr.length;i++){         //遍历数组，拿到json对象
        cs[cs_arr[i].split('=')[0]] = cs_arr[i].split('=')[1]
        }
    }
    return cs;
}

function isVehicleNumber(vehicleNumber) {
  var xreg=/^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF]$)|([DF][A-HJ-NP-Z0-9][0-9]{4}$))/;
  var creg=/^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}$/;
  if(vehicleNumber.length == 7){
    return creg.test(vehicleNumber);
  } else if(vehicleNumber.length == 8){
    return xreg.test(vehicleNumber);
  } else{
    return false;
  }
}

function isVIN(vin){
	if(vin.length>0 && vin.length!=17){
		return false;
	}else{
		var vinVal = vin.toUpperCase();
		var charToNum = {'A':1,'B':2,'C':3,'D':4,'E':5,'F':6,'G':7,'H':8,'J':1,'K':2,'L':3,'M':4,'N':5,'P':7,'R':9,'S':2,'T':3,'U':4,'V':5,'W':6,'X':7,'Y':8,'Z':9};
		var obj = 0;
		var arr = new Array();
		for (var i = 0 ; i < vinVal.length; i++) {
			var temp = vinVal.charAt(i);

			if(charToNum[temp]){
				arr[i] = charToNum[temp];
			}else{
				arr[i] = Number(temp);
			}
			if(i==8){
				arr[i] = vinVal.charAt(i);
			}
		};	
		var a1 = 8;
		for (var i = 0; i < 7; i++) {
			obj += Number(arr[i]) * a1 ;
			a1--;
		};
		obj += Number(arr[7])*10;
		var a2 = 9;
		for (var i = 9; i < 17; i++) {
			obj += Number(arr[i]) * a2;
			a2--;
		};
		var result = Number(obj)%11; 
		if(parseInt(result) === 10){
			result = 'X';
		}
		if(result == arr[8]){
				//成功
			return true;
		}else{
			//失败
			return false;
		}
	}
}

function exportExcel(title,id) {
    let table = document.querySelector(id).cloneNode(true);
    if (table.querySelector(".el-table__fixed-right")) {
        table.querySelector(".el-table__fixed-right").parentNode.removeChild(table.querySelector(".el-table__fixed-right"));
    }
    if (table.querySelector(".el-table__fixed")) {
        table.querySelector(".el-table__fixed").parentNode.removeChild(table.querySelector(".el-table__fixed"));
    }
    /* bulid work sheet from table */
    let wb = XLSX.utils.table_to_book(table,{raw:true});
    /* Get binary string as output */
    let wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
        cellStyles:true,
    });
    try {
        FileSaver.saveAs(
            //Blob Object represents an immutable, original data file-like object.
            //Blob It does not necessarily represent data in JavaScript's native format.
            //File The interface is based on Blob, which inherits the function of blob and extends it to support files on the user's system.
            //Returns a newly created Blob object whose content is composed of the concatenation of the arrays given in the parameters.
            new Blob([wbout], { type: "application/octet-stream" }),
            //Set the export file name
            title + ".xlsx"
        );
    } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
    }
    return wbout;
}
export default {
    exportExcel: function (title, id) {
        return exportExcel(title, id);
    },
    formatDate: function (date, fmt) {
        return formatDate(date, fmt);
    },
    dateDiff: function (interval, date1, date2) {
        return DateDiff(interval, date1, date2);
    },
    getRounding: function (value, num) {
        return getRounding(value, num);
    },
    toFixed: function (value, num) {
        return toFixed(value, num);
    },
    numArrySort: function (arr) {
        return numArrySort(arr);
    },
    getAvgValue: function (arr) {
        return getAvgValue(arr);
    },
    getMedian: function (arr) {
        return getMedian(arr);
    },
    getMedianData: function (arr) {
        return getMedianData(arr);
    },
    downloadFile: function (blobData, blobType, fileName) {
        return DownloadFile(blobData, blobType, fileName);
    }, byteLength: function (str) { return byteLength(str) },
    formatDate24: function (date, fmt) {
        return formatDate24(date, fmt);
    },
    digitNumFormat:function(val, digitNum){
        return DigitNumFormat(val,digitNum);
    },
    getWaterLevel:function(intLeve){
        return GetWaterLevel(intLeve);
    },
    guid:function () {
        return guid();
    },
    getAuditStatus:function(checkLevel,level){
        return getAuditStatus(checkLevel,level);
    },
    getCalendarAuditStatus:function(checkLevel){
        return getCalendarAuditStatus(checkLevel);
    },
    getCalendarAuditStatus1:function(checkLevel){
        return getCalendarAuditStatus1(checkLevel);
    },
    getUrlPara:function(){
        return getUrlPara();
    },
	isVehicleNumber:function(vehicleNumber){
        return isVehicleNumber(vehicleNumber);
    },
	isVIN:function(vin){
		return isVIN(vin);
	}
}